/**
 * Allowed file types for request attachments in the EMEA tenant.
 * Mirrors the legacy `packages/frontend` EMEA accept list to restrict uploads
 * to a known set of document/image/archive formats.
 */
export const EMEA_REQUEST_ATTACHMENT_ACCEPT =
    'image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.html,.docm,application/zip,application/x-zip-compressed,.DOC,.DOCX,.XLS,.XLSX,.PPT,.PPTX,.TXT,.CSV,.HTML,.DOCM';
